import {Box, Grid} from "@mui/material";
import {useEffect, useState} from "react";

import Loader from "components/Loader";
import {Outlet} from "react-router-dom";
import {DRAWER_WIDTH} from "config";
import { getItem as getBusiness} from "store/reducers/business";
import { dispatch } from "store";

const AttendancBase = () =>{

    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        dispatch(getBusiness());
        setLoading(true)
    });


    if (!loading  ) return <Loader />;
    return ( <Grid container spacing={3} direction={"column"}>
        <Grid item container spacing={2} xs={12}  justifyContent={"flex-start"}>

        </Grid>
        <Grid item container spacing={2} xs={12}  >
            <Box component="main" sx={{ width: `calc(100% - ${DRAWER_WIDTH}px)`, flexGrow: 1, p: { xs: 2, sm: 3 } }}>
                <Outlet />
            </Box>
        </Grid>
    </Grid>);
}
export default AttendancBase;
